import React, { Component } from 'react'
import TablaDistribucionPorCereal from '../../shared/distribucionPorCereal/containers/TablaDistribucionPorCereal'
import TablaDetallePorCerealLinea12 from '../../detallesDistribucionPorCereal/detallePorCerealLinea12/containers/TablaDetallePorCerealLinea12'
import TablaDetallePorCerealLinea3 from '../../detallesDistribucionPorCereal/detallePorCerealLinea3/containers/TablaDetallePorCerealLinea3'
import TablaDetallePorCerealLinea4 from '../../detallesDistribucionPorCereal/detallePorCerealLinea4/containers/TablaDetallePorCerealLinea4'
import TablaDetallePorCerealLinea5 from '../../detallesDistribucionPorCereal/detallePorCerealLinea5/containers/TablaDetallePorCerealLinea5'

export class DistribucionPorCerealView extends Component {
  render () {
    return (
      <>
        <TablaDistribucionPorCereal conLink={false} />
        <TablaDetallePorCerealLinea12 />
        <TablaDetallePorCerealLinea3 />
        <TablaDetallePorCerealLinea4 />
        <TablaDetallePorCerealLinea5 />
      </>
    )
  }
}
